import { defineMessages } from 'react-intl';

const translations = {
  actions: {
    cancelAllocation: {
      id: 'pages.orderItems.actions.cancelAllocation',
      defaultMessage: 'Cancel allocation',
      description: 'Title of the action cancel allocation',
    },
    changeRoute: {
      id: 'pages.orderItems.actions.changeRoute',
      defaultMessage: 'Change route',
      description: 'Title of the action change route',
    },
    createOrder: {
      id: 'pages.orderItems.actions.createOrder',
      defaultMessage: 'Place on order',
      description: 'Title of the action create order',
    },
  },
  confirmCancelAllocation: {
    title: {
      id: 'pages.orderItems.confirmCancelAllocation.title',
      defaultMessage: 'Cancel items stock allocation',
      description: 'Title of the confirm cancel allocation dialog',
    },
    description: {
      id: 'pages.orderItems.confirmCancelAllocation.description',
      defaultMessage:
        'Are you sure you would like to cancel the stock allocation for the selected items? The stock allocation will only be cancelled for items that are available and are not on any shipments.',
      description: 'Title of the confirm cancel allocation dialog',
    },
    buttons: {
      cancel: {
        id: 'actions.cancel',
        defaultMessage: 'Cancel',
        description: 'Label of the cancel button in the confirm cancel allocation dialog',
      },
      continue: {
        id: 'actions.continue',
        defaultMessage: 'Continue',
        description: 'Label of the continue button in the confirm cancel allocation dialog',
      },
    },
  },
  feedback: {
    itemAllocationCancelled: {
      id: 'pages.orderItems.feedback.itemAllocationCancelled',
      defaultMessage: 'Items stock allocation cancelled',
      description: 'Item cancel stock allocation success message',
    },
    itemAllocationNotCancelled: {
      id: 'pages.orderItems.feedback.itemAllocationNotCancelled',
      defaultMessage: 'Items stock allocation could not be cancelled',
      description: 'Item cancel stock allocation error message',
    },
    orderNotCreated: {
      id: 'pages.orderItems.feedback.orderNotCreated',
      defaultMessage: 'Order could not be created',
      description: 'Order created error message',
    },
  },
};

export default defineMessages(translations);
